// Shape of one entry in a role's sidebar menu (assigned_module.assign_mods).
// Groups (isParent) carry their sub-pages in subLink.
export function toMenuItem(page) {
  const isGroup = Number(page.isParent) === 1;
  return {
    id: page.id,
    title: page.title,
    icon: page.icon,
    route: page.route,
    parentID: page.parentID ?? null,
    isParent: isGroup ? 1 : 0,
    ...(isGroup ? { subLink: (page.subLink || []).map(toMenuItem) } : {}),
  };
}

export function parseMenu(raw) {
  try {
    const list = JSON.parse(raw || '[]');
    return Array.isArray(list) ? list.map(toMenuItem) : [];
  } catch {
    return [];
  }
}

export function countPages(menu) {
  return menu.reduce((n, i) => n + (i.isParent ? (i.subLink || []).length : 1), 0);
}
